module.exports = __webpack_public_path__ + "media/crypto/wbtc-f1e651ea.png";